import { render, staticRenderFns } from "./CallTreatmentConfig.vue?vue&type=template&id=245ff045&scoped=true&"
import script from "./CallTreatmentConfig.vue?vue&type=script&lang=js&"
export * from "./CallTreatmentConfig.vue?vue&type=script&lang=js&"
import style0 from "./CallTreatmentConfig.vue?vue&type=style&index=0&id=245ff045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ff045",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VForm,
  VLayout,
  VSelect,
  VTextField,
})
